<ion-header *ngIf="isMobile">
  <sb-simple-navbar [hasBackButton]="true" [fakeButton]="true">
    <h4 class="sb-back--title color-light">{{ team }}</h4>
  </sb-simple-navbar>
</ion-header>
<ion-content *ngIf="isMobile" [ngClass]="{'no-scroll': globalVars?.iosScrollHide}">
  <ng-container *ngIf="teamEvents$ | async as teamEvents">
    <sb-header-with-counter [text]="'Pr&oacute;ximos partidos'">
    </sb-header-with-counter>
    <sb-grid-item
      *ngFor="let event of teamEvents; trackBy: utils?.trackBy"
      [event]="event"
      [mode]="event?.mode"
      [hasBets]="!!event?.Games?.length"
      (navigate)="navigate(event)"
    >
      <ng-container
        *ngTemplateOutlet="
          event?.mode === 'teams' ? teams : expanded;
          context: { event: event }
        "
        content
      >
      </ng-container>
      <sb-overview-score-sets
        *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.SETS"
        [sportHandle]="event?.SportHandle"
        [scoreboard]="event?.liveData"
        scoreboard
      >
      </sb-overview-score-sets>

      <sb-overview-score-regular
        *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.REGULAR"
        [scoreboard]="event?.liveData"
        scoreboard
      >
      </sb-overview-score-regular>

      <div
        class="sb-grid-item--bets-group"
        [ngClass]="'has-' + event?.Games?.length + '-groups'"
        [game]="game"
        *ngFor="let game of event?.Games; let index = index"
        bet-display
        [betType]="game?.DisplayTypeName"
        sb-markets
      >
        <sb-button
          *ngFor="
            let result of game?.Results;
            let index = index;
            trackBy: utils?.trackBy
          "
          [type]="game?.GameType"
          [typeName]="game?.DisplayTypeName"
          [game]="result"
          [results]="game?.Results"
          [index]="index"
          (bet)="bet($event, event, game?.Name)"
          [selected]="newTicketFacade?.hasResult(result.NodeId)"
          [locked]="result?.Locked"
          [home]="event?.teamHome"
          [away]="event?.teamAway"
          [sport]="event?.SportHandle"
        >
        </sb-button>
      </div>
    </sb-grid-item>
  </ng-container>

  <ng-container *ngIf="teamSpecials$ | async as teamSpecials">
    <sb-header-with-counter [text]="'Apuestas especiales'">
    </sb-header-with-counter>
    <sb-grid-item
      *ngFor="let event of teamSpecials; trackBy: utils?.trackBy"
      [special]="true"
      [event]="event"
      [mode]="event?.mode"
      [hasBets]="!!event?.Games?.length"
      (navigate)="navigate(event)"
    >
      <sb-grid-content-expanded [title]="event?.Name" [date]="event?.StartDate | sportsExtractDate" content>
      </sb-grid-content-expanded>

      <sb-overview-score-sets
        *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.SETS"
        [sportHandle]="event?.SportHandle"
        [scoreboard]="event?.liveData"
        scoreboard
      >
      </sb-overview-score-sets>

      <sb-overview-score-regular
        *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.REGULAR"
        [scoreboard]="event?.liveData"
        scoreboard
      >
      </sb-overview-score-regular>

      <div
        class="sb-grid-item--bets-group"
        [ngClass]="'has-' + event?.Games?.length + '-groups'"
        [class.has-callback]="event?.Games?.length % 2 !== 0"
        [game]="game"
        *ngFor="let game of event?.Games; let index = index"
        bet-display
        [betType]="game?.DisplayTypeName"
        sb-markets
      >
        <sb-button
          *ngFor="
            let result of game?.Results;
            let index = index;
            trackBy: utils?.trackBy
          "
          [type]="game?.GameType"
          [typeName]="game?.DisplayTypeName"
          [game]="result"
          [results]="game?.Results"
          [index]="index"
          (bet)="bet($event, event, game?.Name)"
          [selected]="newTicketFacade?.hasResult(result.NodeId)"
          [locked]="result?.Locked"
          [home]="event?.teamHome"
          [away]="event?.teamAway"
          [sport]="event?.SportHandle"
        >
        </sb-button>
      </div>
    </sb-grid-item>
  </ng-container>

  <codere-footer></codere-footer>
</ion-content>
<ion-grid *ngIf="!isMobile" class="tablet-common-grid">
  <ion-row no-padding no-margin>
    <ion-col [class.leftMenuOpen]="globalVars?.leftMenuOpen" no-padding>
      <ion-content>
        <div class="sb-sticky">
          <!-- todo quitamos [nav]="navCtrl" revisar como afecta esto al componente -->
          <sb-simple-navbar [hasBackButton]="true" [fakeButton]="true">
            <h4 class="sb-back--title color-light">{{ team }}</h4>
          </sb-simple-navbar>
        </div>
        <ng-container *ngIf="teamEvents$ | async as teamEvents">
          <sb-header-with-counter [text]="'Pr&oacute;ximos partidos'">
          </sb-header-with-counter>
          <sb-grid-item
            *ngFor="let event of teamEvents; trackBy: utils?.trackBy"
            [event]="event"
            [mode]="event?.mode"
            [hasBets]="!!event?.Games?.length"
            (navigate)="navigate(event)"
          >
            <ng-container
              *ngTemplateOutlet="
                event?.mode === 'teams' ? teams : expanded;
                context: { event: event }
              "
              content
            >
            </ng-container>
            <sb-overview-score-sets
              *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.SETS"
              [sportHandle]="event?.SportHandle"
              [scoreboard]="event?.liveData"
              scoreboard
            >
            </sb-overview-score-sets>

            <sb-overview-score-regular
              *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.REGULAR"
              [scoreboard]="event?.liveData"
              scoreboard
            >
            </sb-overview-score-regular>

            <div
              class="sb-grid-item--bets-group"
              [ngClass]="'has-' + event?.Games?.length + '-groups'"
              [game]="game"
              *ngFor="let game of event?.Games; let index = index"
              bet-display
              [betType]="game?.DisplayTypeName"
              sb-markets
            >
              <sb-button
                *ngFor="let result of game?.Results; let index = index; trackBy: utils?.trackBy"
                [type]="game?.GameType"
                [typeName]="game?.DisplayTypeName"
                [game]="result"
                [results]="game?.Results"
                [index]="index"
                (bet)="bet($event, event, game?.Name, '1')"
                [selected]="newTicketFacade?.hasResult(result.NodeId)"
                [locked]="result?.Locked"
                [home]="event?.teamHome"
                [away]="event?.teamAway"
                [sport]="event?.SportHandle"
              >
              </sb-button>
            </div>
          </sb-grid-item>
        </ng-container>

        <ng-container *ngIf="teamSpecials$ | async as teamSpecials">
          <sb-header-with-counter [text]="'Apuestas especiales'">
          </sb-header-with-counter>
          <sb-grid-item
            *ngFor="let event of teamSpecials; trackBy: utils?.trackBy"
            [special]="true"
            [event]="event"
            mode="expanded"
            [hasBets]="!!event?.Games?.length"
            (navigate)="navigate(event)"
          >
            <sb-grid-content-expanded [title]="event?.Name" [date]="event?.StartDate | sportsExtractDate" content>
            </sb-grid-content-expanded>
            <sb-overview-score-sets
              *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.SETS"
              [sportHandle]="event?.SportHandle"
              [scoreboard]="event?.liveData"
              scoreboard
            >
            </sb-overview-score-sets>

            <sb-overview-score-regular
              *ngIf="event?.overviewScoreboard === SCOREBOARD_TYPE.REGULAR"
              [scoreboard]="event?.liveData"
              scoreboard
            >
            </sb-overview-score-regular>

            <div
              class="sb-grid-item--bets-group"
              [ngClass]="'has-' + event?.Games?.length + '-groups'"
              [game]="game"
              *ngFor="let game of event?.Games; let index = index"
              bet-display
              [betType]="game?.DisplayTypeName"
              sb-markets
            >
              <sb-button
                *ngFor="let result of game?.Results; let index = index; trackBy: utils?.trackBy "
                [type]="game?.GameType"
                [typeName]="game?.DisplayTypeName"
                [game]="result"
                [results]="game?.Results"
                [index]="index"
                (bet)="bet($event, event, game?.Name, '2')"
                [selected]="newTicketFacade?.hasResult(result.NodeId)"
                [locked]="result?.Locked"
                [home]="event?.teamHome"
                [away]="event?.teamAway"
                [sport]="event?.SportHandle"
              >
              </sb-button>
            </div>
          </sb-grid-item>
        </ng-container>
        <codere-footer></codere-footer>
      </ion-content>
    </ion-col>
  </ion-row>
</ion-grid>

<!--Overview Pages-->
<ng-template #teams let-event="event" content>
  <sb-grid-content-teams [event]="event" content></sb-grid-content-teams>
</ng-template>
<ng-template #expanded let-event="event" content>
  <sb-grid-content-expanded [title]="event?.Name" [date]="event?.StartDate | sportsExtractDate" content>
  </sb-grid-content-expanded>
</ng-template>
